export const siteTitle = "Have I been arbed yet?";
export const siteDescription = `Quickly find out if your protocol / exchange or ERC20 token has been arbed. Built on the graph - the api is decentralized`;
